import React, { useRef, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Portal from '../../DesignerCommon/portal'
import useOnClickOutside from '../../../hooks/useOnClickOutside'
import { fetchFeed, setAttr } from '../../../redux/feedInfiniteSlice'
import { FEED_RESET } from '../../../redux/constants'
import CloseIcon from '../../../assets/close.svg'
import {
  ModalWindow,
  ModalWrapper,
  Title,
  Grid,
  Card,
  Submit,
  CloseButton
} from './ChooseTemplate.styles'
import TemplateTabs from '../../DesignerDesigns/tabs/TemplateTabs'
import { ReactComponent as SelectedIcon } from '../../../assets/template-selected.svg'

export const ChooseTemplate = ({ onClose, setValue, fieldName }) => {
  const [category, setCategory] = useState('17006')
  const [selected, setSelected] = useState(null)
  const dispatch = useDispatch()
  const { feed: templates, loading } = useSelector(state => state.template)
  const ref = useRef()

  useOnClickOutside(ref, () => {
    onClose()
  })

  useEffect(() => {
    if (!category) return
    window.scrollTo(0, 0)
    if (fieldName === 'inspirationImage') {
      dispatch(
        setAttr('template')({
          addition: {
            statuses: ['userEvent'],
            categoryId: category
          }
        })
      )
    } else {
      dispatch(
        setAttr('template')({
          addition: {
            categoryId: category
          }
        })
      )
    }

    dispatch(fetchFeed('template')({ status: FEED_RESET }))
  }, [category, dispatch, fieldName])

  const handleSubmit = value => {
    setSelected(value)
    onClose()
  }

  return (
    <Portal>
      <ModalWrapper>
        <ModalWindow ref={ref}>
          <CloseButton onClick={onClose}>
            <img src={CloseIcon} alt="Close" />
          </CloseButton>

          <Title>Choose From Our Library</Title>
          <TemplateTabs
            onSelect={d => {
              setCategory(d.value)
            }}
            selected={category}
          />
          {!!templates.length && (
            <Grid>
              {templates.map(({ objectId, cfImageUrl }) => (
                <Card
                  key={objectId}
                  onClick={() => setSelected(cfImageUrl)}
                  isSelected={cfImageUrl === selected}
                >
                  <img src={cfImageUrl} />
                  {cfImageUrl === selected && <SelectedIcon />}
                </Card>
              ))}
            </Grid>
          )}
          {selected && (
            <Submit
              onClick={() => {
                setValue(selected)
                onClose()
              }}
            >
              Choose
            </Submit>
          )}
        </ModalWindow>
      </ModalWrapper>
    </Portal>
  )
}
